<template>
  <router-view />
</template>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
ul,
li {
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  width: 100%;
  height: 100%;
}
#app {
  min-width: 1150px;
}
</style>
